/**
 * The credits banner slot's height, in px (Figma 16346-95088): 20 top gap + a 54 pill + a 16 gap
 * before the page content. AppFrame publishes it as `--credits-banner-h` while the banner shows; the
 * content region insets its top by it (globals.css `.orion-content-region`) so the banner sits above
 * the page's own header and pushes the content — not the rail — down, and the `.orion-credits-banner-slot`
 * strip fills it with the centered pill.
 */
export const CREDITS_BANNER_HEIGHT_PX = 90;
